import { AsideBanner, GuideDetail, PieceBanner, Refund, TotalPrice } from "@/domains/components";
import { useGetGuide, type GuideBaseInfoResponse } from "@/shared/server";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";

export const Guide = () => {
    const { data } = useGetGuide<GuideBaseInfoResponse>();
    const { idx } = getDefaultParameters();
    return data ? (
        <Box w="100%">
            <PieceBanner
                imgUrl={data.imgUrl}
                name={data.pensionInfo.name}
                title={{
                    main: "Notice",
                    sub: "종합 예약안내",
                }}
            />
            <GuideDetail />
            <Refund />
            {idx !== "2017" && <TotalPrice />}

            <AsideBanner isFullImg={false} />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
